import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Id: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="3"
        stroke={color}
        strokeWidth="2"
      />
      <path d="M8.74 8H7V16.16H8.74V8Z" fill={color} />
      <path
        d="M10.9516 8V16.16H14.1316C16.6396 16.16 18.4996 14.42 18.4996 12.044C18.4996 9.716 16.6396 8 14.1316 8H10.9516ZM12.6916 14.564V9.584H14.1316C15.5836 9.584 16.7356 10.676 16.7356 12.044C16.7356 13.46 15.5836 14.564 14.1316 14.564H12.6916Z"
        fill={color}
      />
    </svg>
  );
};

export default Id;
